import React from 'react'
import PropTypes from 'prop-types'
import update from 'immutability-helper'
import { midas } from '@resurs/midas'

import { Button } from '../../Button'

export class SearchField extends React.PureComponent {
  constructor(props) {
    super(props)
    this.keyEnterListener = this.keyEnterListener.bind(this)
    this.state = {
      term: this.props.searchTerm,
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) { //eslint-disable-line
    if (nextProps.searchTerm !== this.state.term) {
      this.onChange(nextProps.searchTerm)
    }
  }

  onChange(value) {
    this.setState(
      update(this.state, {
        term: { $set: value },
      }),
    )
  }

  onSearch() {
    this.props.onSearch(this.state.term)
  }

  inFocus() {
    window.addEventListener('keyup', this.keyEnterListener)
  }

  focusLost() {
    window.removeEventListener('keyup', this.keyEnterListener)
  }

  keyEnterListener(event) {
    if (event.keyCode === 10 || event.keyCode === 13) {
      event.preventDefault()
      this.onSearch()
    }
  }

  render() {
    return (
      <div className={midas.inputGroup}>
        <input
          style={{ height: '3.5rem' }}
          type="text"
          name={this.props.id}
          id={this.props.id}
          value={this.state.term}
          onChange={e => this.onChange(e.target.value)}
          className={midas.formInput}
          placeholder={this.props.placeholder}
          onFocus={() => this.inFocus()}
          onBlur={() => this.focusLost()}
        />
        <Button
          text={this.props.buttonText}
          typeName={this.props.buttonType}
          onClick={e => this.onSearch(e)}
          inputGroup
        />
      </div>
    )
  }
}
SearchField.defaultProps = {
  searchTerm: '',
}

SearchField.propTypes = {
  id: PropTypes.string,
  placeholder: PropTypes.string.isRequired,
  buttonText: PropTypes.string.isRequired,
  buttonType: PropTypes.string,
  onSearch: PropTypes.func.isRequired,
  searchTerm: PropTypes.string,
}

SearchField.defaultProps = {
  id: 'searchfield-search',
  buttonType: 'primary',
}
